import firebase from 'firebase/app';
import 'firebase/firebase-analytics';

interface Response {
  totalServicios: number,
  totalAmount: number,
  totalKm: number,
  totalTime: string,
  usuariosTotales: number,
  driversTotales: number,
  deliveryTotales: number,
}

class ResumeService {

  #_fr = firebase.firestore();

  async getResume(): Promise<Response> {
    const _dt = new Date();
    const initialDate = new Date(_dt.getFullYear(), _dt.getMonth(), _dt.getDay(), 0, 0, 0);
    const finalDate = new Date(_dt.getFullYear(), _dt.getMonth(), _dt.getDay(), 23, 59, 59);



    const results = await this.#_fr.collection("bookings")
      .where("state", "==", "finish")
      .where("createdAt", ">=", initialDate)
      .where("createdAt", "<=", finalDate).get();
    
    const resultUsers = await this.#_fr.collection("users").get();

    var totalAmount = 0;
    var totalKm = 0;
    var totalServicios = 0;
    var totalTime = 0;

    var usuariosTotales = 0;
    var driversTotales = 0;
    var deliveryTotales = 0;

    for (const booking of results.docs) {
      const element = booking.data();

      if ("abordedAt" in element && "finishAt" in element && "bookingValue" in element && ("reason" in element) === false) {
        totalKm += parseInt(element.distance);
        totalAmount += parseInt(element.bookingValue);

        const timeStart = (element.abordedAt as firebase.firestore.Timestamp).toDate().getTime();
        const timeEnd = (element.finishAt as firebase.firestore.Timestamp).toDate().getTime();
        const minDiff = (timeEnd - timeStart) / 60 / 1000; //in minutes
        totalTime += Math.round(minDiff);
        totalServicios++;
      }
    }

    for (const user of resultUsers.docs) {
      const element = user.data();
      const role = element.role;

      if (role === "USER") {
        usuariosTotales++;
      } else if (role === "DRIVER") {
        driversTotales++;

        if (!!element.isMultiService) {
          deliveryTotales++;
        }
      } else if (role === "DELIVERY") {
        deliveryTotales++;
      }
    }

    return {
      totalAmount,
      totalKm: Math.round(totalKm / 1000),
      totalServicios,
      totalTime: totalTime + " mins",
      usuariosTotales,
      driversTotales,
      deliveryTotales,
    }
  }
}

export default ResumeService;